import React from "react";
import { Button } from "../Shared";
import { Date, Exit, Home, Logo, Star, User } from "../../assets/icons";
import moment from "moment-jalaali";
import { persianDaysArray } from "../../Utils/PersianDaysArray";
import { useDispatch, useSelector } from 'react-redux';

const MenuMain = (props) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.auth.userInfo)
  function getDay() {
    const day = moment().day();
    return persianDaysArray[day];
  }

  const isFaNum = useSelector(
    (state) => state.persistedParams.isFaNum
  )

  const logout = () => {
    dispatch({
      type: "IS_LOGIN",
      isLogin: false,
      token: null
    })

  }

  function changeIsFaNum(e) {
    dispatch({
      type: "IS_FA_NUM",
      payload: e
    })
  }

  return (
    <div className="menuMain">
      <div className="_profile">
        <Logo className="_logo" />
        <div className="_time">
          <span className="_day">
            <span>{getDay()}</span>
            <Date className="_icon" />
          </span>
          <time >{moment().format('jYYYY/jMM/jDD')}</time>
        </div>
      </div>
      <div className="_language">
        <Button to="/">
          <div>
            <i class="fa fa-language"></i>
            <span>انتخاب زبان</span>
          </div>
          <div className="_lang">
            <Button className={isFaNum ? "_fa_da" : "_fa"} onClick={() => changeIsFaNum(true)}>
              Fa
				</Button>
            <div className='_slash'>/</div>
            <Button className={!isFaNum ? "_en_da" : "_en"} onClick={() => changeIsFaNum(false)}>
              En
				</Button>
          </div>
        </Button>
      </div>
      <div className="_phone">
        <Button to="/">
          <User className="_icon" />
          <span>{userInfo?.mobile || ''}</span>
        </Button>
      </div>
      <nav className="_menu">
        <ul>
          <li>
            <Button to="/">
              <Home className="_icon" />
              <span>صفحه اصلی</span>
            </Button>
          </li>
          {/* <li>
						<Button to="/charts">
							<Chart className="_icon" />
							<span>نمودار قیمت ها</span>
						</Button>
					</li> */}
          <li>
            <Button to="/subscription">
              <Star className="_icon" />
              <span>اشتراک</span>
            </Button>
          </li>
          <li>
            <Button onClick={logout} className="_btn">
              <Exit className="_icon" />
              <span>خروج</span>
            </Button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MenuMain;
